import type { AppSelectOption } from '@/components/AppSelectField.vue'

/** 音轨 1–4（音频播放/淡出事件）。 */
export const AUDIO_TRACK_OPTIONS: AppSelectOption[] = [
  { label: '音轨1', value: 0 },
  { label: '音轨2', value: 1 },
  { label: '音轨3', value: 2 },
  { label: '音轨4', value: 3 },
]

/** 帧 / 秒（等待、震动、移动图片、旋转图片等）。 */
export const FRAME_SECONDS_OPTIONS: AppSelectOption[] = [
  { label: '帧', value: 0 },
  { label: '秒', value: 1 },
]

/** 天气类型（Code 301）。 */
export const WEATHER_OPTIONS: AppSelectOption[] = [
  { label: '无天气效果', value: 0 },
  { label: '刮风', value: 1 },
  { label: '下雨', value: 2 },
  { label: '下雪', value: 3 },
]

/** 鼠标条件区域类型。 */
export const MOUSE_RECT_TYPE_OPTIONS: AppSelectOption[] = [
  { label: '矩形区域', value: 0 },
  { label: '整张图片', value: 1 },
]

/** 旋转图片中点类型。 */
export const ROTATE_POINT_RATE_OPTIONS: AppSelectOption[] = [
  { label: '中心', value: 0 },
  { label: '左上', value: 1 },
  { label: '自定义', value: 10 },
]

/** 数值操作：指定数值 / 索引数值。 */
export const NUMERIC_TARGET_MODE_OPTIONS: AppSelectOption[] = [
  { label: '指定数值', value: 'direct' },
  { label: '索引数值', value: 'index' },
]

/** 字符串事件：字符串 / 数值指定字符串。 */
export const STRING_TARGET_MODE_OPTIONS: AppSelectOption[] = [
  { label: '字符串', value: 'string' },
  { label: '数值指定字符串', value: 'var' },
]
